import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Animated, View } from 'react-native';
import { CoreConfig } from './../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { SmallView } from '../Typography/SmallView';
import { LoadingView } from './LoadingView';
import { useDimensionAnimation } from '../Animations/AnimationHooks';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
export const NotificationView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.notification,
    style: {
        container: {
            position: 'absolute',
            left: 0,
            right: 0,
            flexDirection: 'row',
            justifyContent: 'center'
        },
        content: {
            flexDirection: 'row',
            padding: 10,
            backgroundColor: '#394E66',
            borderRadius: 8
        },
        text: {
            textAlign: 'center',
        },
        loader: {
            position: 'relative',
            flex: undefined,
            width: undefined,
            height: undefined,
            marginEnd: 10
        }
    }
})(({ value, style }) => {
    const [animation, setAnimation] = useDimensionAnimation({ initialValue: 0 });
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        setAnimation(value.enabled
            ? 1
            : 0);
        const timeout = setTimeout(() => {
            setIsVisible(value.enabled);
        }, 300);
        return () => {
            clearTimeout(timeout);
        };
    }, [value.enabled]);
    const bottom = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 10]
    });
    const styles = [
        style === null || style === void 0 ? void 0 : style.container,
        {
            zIndex: isVisible
                ? 1
                : -1,
            opacity: animation,
            bottom
        }
    ];
    return (_jsx(Animated.View, { style: styles, children: _jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [!!value.loader && (_jsx(LoadingView, { containerStyle: style === null || style === void 0 ? void 0 : style.loader })), _jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.text, light: true, children: value.text })] }) }));
});
